import { render } from "./TheLoginForm.vue?vue&type=template&id=971be782&scoped=true&ts=true"
import script from "./TheLoginForm.vue?vue&type=script&lang=ts"
export * from "./TheLoginForm.vue?vue&type=script&lang=ts"

import "./TheLoginForm.vue?vue&type=style&index=0&id=971be782&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-971be782"]])

export default __exports__